module.exports = __webpack_public_path__ + "img/tip-image-2.7b7dfd3f.png";